import { render, staticRenderFns } from "./change-language.vue?vue&type=template&id=948f1d42"
import script from "./change-language.vue?vue&type=script&lang=js"
export * from "./change-language.vue?vue&type=script&lang=js"
import style0 from "./change-language.vue?vue&type=style&index=0&id=948f1d42&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports